import React, { useRef, useState } from "react";
import styled from "styled-components";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import CountryStreamsDetails from "./countryStreamsDetails";
import MapMouseTooltip from "./mapMouseToolTip";

interface IProps {}
const MapChart = () => {
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const mapRef = useRef(null);

  const highlightedCountries = ["Nigeria", "United States", "Australia"];

  return (
    <Container ref={mapRef}>
      <ComposableMap>
        <Geographies
          geography={"/worldmap.json"}
          fill="#909090"
          stroke="#444"
          strokeWidth={0.5}
        >
          {({ geographies }: { geographies: any[] }) =>
            geographies.map((geo: any) => {
              const isHighlighted = highlightedCountries.includes(
                geo.properties.name
              );
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onMouseEnter={() => {
                    setHoveredCountry(geo.properties.name);
                  }}
                  onMouseMove={(e: { clientX: number; clientY: number }) => {
                    setMousePosition({
                      x: e.clientX,
                      y: e.clientY
                    });
                  }}
                  onMouseLeave={() => {
                    setHoveredCountry(null);
                  }}
                  style={{
                    default: {
                      fill: isHighlighted ? "#FED998" : "#909090",
                      outline: "none"
                    },
                    hover: {
                      fill: "#FEC667",
                      outline: "none",
                      stroke: "#FEA101",
                      strokeWidth: 1
                    }
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {hoveredCountry && highlightedCountries.includes(hoveredCountry) && (
        <MapMouseTooltip
          x={mousePosition.x}
          y={mousePosition.y}
          mapRef={mapRef}
        >
          <CountryStreamsDetails
            country={hoveredCountry}
            totalStreamCount={"11,564"}
          />
        </MapMouseTooltip>
      )}
    </Container>
  );
};

export default MapChart;

const Container = styled.div`
  width: 100%;
  position: relative;
`;
